export default class extends HTMLElement {

  /**
  static get observedAttributes() {
    return ['post_id', 'service'];
  }
  */

  constructor() {
    super();
    console.log('Init DSBPost');
    this.post_data = [];
    this.append_content = [];
    this.footer = [];
    this.is_refresh = false
    this._navigationHandler = null;
    this.page_view_settings = false;

  }

  get service() {
      return this.getAttribute('service');
  }

  set service(newValue){
      this.setAttribute('service', newValue);
  }

  get settings() {

      let settings = this.getAttribute('settings');
      if(typeof settings !== 'object')
      {
        settings = JSON.parse(settings);
      }
      return settings;
  }

  set settings(newValue){
      this.setAttribute('settings', newValue);
  }

  get template_path() {
      return this.getAttribute('template_path');
  }

  set template_path(newValue){
      this.setAttribute('template_path', newValue);
  }

  get post_id() {
      let post_id = this.getAttribute('post_id');
      if(this.service == 'static')
      {
          post_id = 'json_by_id/'+post_id;
      }
      return post_id;
  }

  get link_path(){
    return this.service+'/'+this.post_id;
  }

  set post_id(newValue){
      this.setAttribute('post_id', newValue);
  }

  get nav_parent_id() {
      return this.getAttribute('nav_parent_id');
  }

  set nav_parent_id(newValue){
      this.setAttribute('nav_parent_id', newValue);
  }

  get post_uri() {
      return this.getAttribute('post_uri');
  }

  set post_uri(newValue){
      this.setAttribute('post_uri', newValue);
  }

  get img_path() {
      return this.getAttribute('img_path');
  }

  set img_path(newValue){
      this.setAttribute('img_path', newValue);
  }

  get type() {
      return this.getAttribute('type');
  }

  get supports()
  {
    return {"offline":true};
  }

  set type(newValue){
      this.setAttribute('type', newValue);
  }

  setDSBClient(dsbClient){
      this.dsbClient=dsbClient;
  }

  setPostList(list){
      this.postList=list;
  }

  setPostData(data){
      this.post_data=[data];
  }

  reset()
  {
    this.post_data = [];
  }

  appendContent(data){
      this.append_content.push(data);
  }

  addFooter(data){
      this.footer.push(data);
  }

  resetFooter(){
      this.footer = [];
  }

  connectedCallback()
  {
    return this._render();
  }

  /**
  attributeChangedCallback(name, oldValue, newValue)
  {
    console.log('attributeChangedCallback..'+name);
    return this._render();
  }
  */

  _createUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  _generate_a_post_widget(widget)
  {
    let component = false;
    if(`type` in widget)
    {
        switch(widget.type)
        {
            case "WP_Widget_Text":
                    component = document.createElement("div");
                    component.innerHTML = widget.data;
                break;
            case "Pm_Datastore_Builder_Client_Widget":
                if(`data` in widget)
                {
                    component = document.createElement("dsb-list");
                    component.setDSBClient(this.dsbClient);

                    if(`layout_settings` in widget.data && (widget.data.layout_settings.length > 0))
                    {
                      component.setAttribute(`settings`, widget.data.layout_settings);
                    }
                    else
                    {
                      component.setAttribute(`settings`, JSON.stringify({'show-thumbnail':'left',"layout-grid": "1"}));
                    }

                    if(`query` in widget.data)
                    {
                        if(`query` in widget.data.query)
                        {
                            component.setAttribute(`query`, widget.data.query.query);
                        }
                        if(`type` in widget.data.query)
                        {
                            component.setAttribute(`service`, widget.data.query.type);
                        }
                    }
                    //component.setAttribute(`root_path`, this.layout);
                    component.innerHTML = `<maa-spinner></maa-spinner>`;
                }
                else
                {
                    console.error('.data missing from Pm_Datastore_Builder_Client_Widget');
                }
                break;
            default:
                break;
        }
    }
    return component;
  }

  _generate_post_widgets(post_widgets,body)
  {
    console.debug("Settings post_widgets...");
    let has_widgets = false;
    let cell_count = 5;
    if(`grid` in post_widgets)
    {
        let _post_widgets = document.createElement("div");
        _post_widgets.setAttribute('class','post_widgets');
        for(let i in post_widgets.grid)
        {
            let row_settings = false;
            if((`settings` in post_widgets) && (`rows` in post_widgets.settings))
            {
                if(grid_row in post_widgets.settings.rows)
                {
                    row_settings = post_widgets.settings.rows[grid_row];
                }
            }

            let grid_row = document.createElement("div");
            grid_row.setAttribute('class','post_widgets-row');
            let grid_cell = Array.apply(null, Array(5)).map(function () {});
            delete grid_cell[0];

            for(let ii in grid_cell)
            {
                grid_cell[ii] = document.createElement("div");
                grid_cell[ii].setAttribute('class','post_widgets-item');
                if(!(ii in post_widgets.grid[i]))
                {
                     grid_cell[ii].innerHTML = `&nbsp;`;
                    if(row_settings && (`fill` in row_settings) && (row_settings.fill == 'yes'))
                    {
                         delete grid_cell[ii];
                    }
                }
                else
                {
                    if(`span` in post_widgets.grid[i][ii] && post_widgets.grid[i][ii].span>1)
                    {
                         grid_cell[ii].setAttribute('style','flex-grow:'+post_widgets.grid[i][ii].span);
                         let del_count = (Number(post_widgets.grid[i][ii].span) - 1);
                         let del_start = (Number(ii) + 1);
                         for (let span_i = del_start; span_i < 5; span_i++)
                         {
                            if(del_count<1)
                            {
                                break;
                            }
                            delete grid_cell[span_i];
                            del_count--;
                         }
                    }
                    let thisWidget = this._generate_a_post_widget(post_widgets.grid[i][ii]);
                    if(thisWidget)
                    {
                        grid_cell[ii].innerHTML = ``;
                        grid_cell[ii].append(thisWidget);
                    }
                    else
                    {
                        grid_cell[ii].innerHTML = `&nbsp;`;
                        if(row_settings && (`fill` in row_settings) && (row_settings.fill == 'yes'))
                        {
                                delete grid_cell[ii];
                        }
                    }

                }
            }

            for( let aCell in grid_cell)
            {
                grid_row.append(grid_cell[aCell]);
            }
            _post_widgets.append(grid_row);
            body.append(_post_widgets);
            has_widgets = true;
        }
    }
    return has_widgets;
  }

   _log(type,source,message,data='')
  {
    let _message = 'dsb-app/DSBPOST::'+source+'- '+message;
    switch(type)
    {
       case "debug":
         console.debug(_message,data);
        break;
      case "warning":
         console.warn(_message,data);
        break;
      case "error":
         console.error(_message,data);
        break;
      default:
          console.log(_message,data);
    }
  }

  page_view()
  {
    if(this.page_view_settings)
    {
      console.debug('dsb-post: Running page view...');
      // Emit Page scrollIntoView
      window.dispatchEvent(new CustomEvent('dsb-pwa-page_view', {detail:this.page_view_settings}));
    }
  }

  async _refresh()
  {
    this.is_refresh = true;
    this.reset();
    return this._render();
  }

  async _render()
  {
    let settings = this.settings;

    try
    {

      if(typeof settings === 'object' && settings !== null)
      {
        if(!('internal_links' in settings))
        {
          settings.internal_links = 'new_window';
        }
        if(!('page_view_onload' in settings))
        {
          settings.page_view_onload = 'on';
        }
        if(!('pulldown_refresh' in settings))
        {
          settings.pulldown_refresh = 'on';
        }
        if(!('lazy_images' in settings))
        {
          settings.lazy_images = 'on';
        }
      }
      else
      {
        settings = {};
        settings.internal_links = 'new_window';
        settings.page_view_onload = 'on';
        settings.pulldown_refresh = 'on';
        settings.lazy_images = 'on';
      }


      if(!('title' in settings))
      {
        settings.title = 'default';
      }

      if(!this.is_refresh)
      {
        this.innerHTML = `<maa-spinner></maa-spinner>`;
      }

      //let img_path = `https://stmaadev.blob.core.windows.net/stc-maa-dev-fw-site`;
      //let img_path = `https://stmaaprodfwsite.blob.core.windows.net/assets`;

      let img_path = ``;

      if(this.post_data === undefined || this.post_data.length == 0)
      {
        if(this.post_id && this.service)
        {
          let json = await this.dsbClient.content.get(this.service,this.post_id,true);
          if (json.state)
          {
            this.post_data = json.data;
          }
        }
      }


      if(`image_path` in this.dsbClient.content)
      {
        img_path = this.dsbClient.content.image_path;
      }


      if(this.post_data === undefined || this.post_data.length < 0)
      {
        this.innerHTML = `<article class="error-500" role="article">
          <p>501 :(</p>
          <p>Something seems to have gone wrong...</p>
        </article>`;
      }
      else
      {

        let modal_mode = true;
        var body_modal_panel_id = `dsb-modal-workspace-`+this._createUUID();

        if(this.post_data.length > 0)
        {
            // Some API data found, but *could* be 404 - 0 results!
            let html,template,format,result  = ``;

            var nav_panel = document.createElement("nav");
            var nav_panel_tabs = document.createElement("ul");
            var nav_parent_id = '';

            var section_panel = document.createElement("section");
            var footer_panel = document.createElement("section");
            footer_panel.setAttribute(`class`, `footer`);

            var body_panel = document.createElement("article");
            body_panel.setAttribute(`class`, `post`);
            body_panel.setAttribute(`role`, `article`);
            body_panel.setAttribute(`itemscope`, ``);
            body_panel.setAttribute(`itemtype`, `http://schema.org/NewsArticle`);

            this.page_view_settings = {};

            // Only grab 1st TODO allow more than one article
            for (let i = 0; i < 1; i++)
            {
              let this_post = this.post_data[i];

              if('document' in this.post_data[i])
              {
                this_post = this.post_data[i].document;
              }

              if(`settings` in this_post)
              {
                for(let this_post_settings__key in this_post.settings)
                {
                  settings[this_post_settings__key]=this_post.settings[this_post_settings__key];
                }
              }

              if(!(`header` in settings))
              {
                settings.header='on';
              }

              if(!(`author` in settings))
              {
                settings.author='on';
              }

              if(('pulldown_refresh' in settings) && (settings.pulldown_refresh == 'on'))
              {
                if(!this.is_refresh)
                {
                  window.dispatchEvent(new CustomEvent('dsb-pwa-add_pulldown_refresh', {detail: {iam: this}}));
                }
              }

              this.page_view_settings = {};
              this.page_view_settings.id=this_post.id;
              this.page_view_settings.date=this.dsbClient.content.format_date(this_post.created_date,'Y-m-d');
              this.page_view_settings.title = this_post.title;
              this.page_view_settings.taxonomies = [];
              this.page_view_settings.types = [];
              this.page_view_settings.customDimensions = {};
              this.page_view_settings.author = '';

              let post_type = this_post.type;

              if(this.post_type && this.post_type.length > 0)
              {
                post_type = this.post_type;
              }

              if(`post` == post_type)
              {
                section_panel.setAttribute(`class`, `page-width`);
                this.page_view_settings.types.push('article');
              }
              else
              {
                body_panel.setAttribute(`class`, `page`);

                if(['fw_dsb_app_tab'].indexOf(post_type) != -1)
                {
                  let base_update_detail = {appname:this_post.title};
                  if('override_title' in settings)
                  {
                    base_update_detail.appname=settings.override_title;
                  }

                  if('flag_beta' in settings && settings.flag_beta=='on')
                  {
                    base_update_detail.appname+='<span style="color:red;font-size:9px;vertical-align:super;padding-left:5px;">beta</span>';
                  }

                  if(!(`base_update` in settings) || settings.base_update!=='off')
                  {
                    window.dispatchEvent(new CustomEvent('dsb-pwa-base_update', {detail:base_update_detail}));
                  }

                  delete this.page_view_settings.title;
                  this.page_view_settings.customDimensions.contenttitle = this_post.title;
                  this.page_view_settings.types.push('app_tab');
                }
                else
                {
                  this.page_view_settings.types.push(post_type);
                }
              }

              let primary_cat = '';
              if('taxonomies' in this_post)
              {
                if('category' in this_post.taxonomies)
                {
                  if('primary_id' in this_post.taxonomies.category)
                  {
                    primary_cat = this.dsbClient.content.applyFilter(`formatData_lookup`, [ `all_cat_obj`, this_post.taxonomies.category.primary_id ] );
                    if(typeof primary_cat === 'object' && primary_cat !== null && 'slug' in primary_cat)
                    {
                      primary_cat = primary_cat.slug;
                      section_panel.classList.add(primary_cat+'-category-col');
                      //this.page_view_settings.sitesection2 = primary_cat;

                      if('list' in this_post.taxonomies.category)
                      {
                        //let sitesection_count = 2;
                        for(let list_item in this_post.taxonomies.category.list )
                        {
                          let acat = this.dsbClient.content.applyFilter(`formatData_lookup`, [ `all_cat_obj`, this_post.taxonomies.category.list[list_item] ] );
                          if(typeof acat === 'object' && acat !== null && 'slug' in acat)
                          {
                            //this.page_view_settings['sitesection'+sitesection_count] = acat.slug;
                            this.page_view_settings.taxonomies.push(acat.slug);
                            //sitesection_count++;
                          }
                        }
                      }
                    }
                  }
                }
                if('article_type' in this_post.taxonomies)
                {
                  if('list' in this_post.taxonomies.article_type)
                  {
                    for(let list_item in this_post.taxonomies.article_type.list )
                    {
                      let acat = this.dsbClient.content.applyFilter(`formatData_lookup`, [ `all_cat_obj`, this_post.taxonomies.article_type.list[list_item] ] );
                      if(typeof acat === 'object' && acat !== null && 'slug' in acat)
                      {
                        //this.page_view_settings.contenttype += "|"+acat.slug;
                        this.page_view_settings.types.push(acat.slug);
                      }
                    }
                  }
                }
              }


              // Set Author
              let author_name = '';
              let advertiser_section = null;
              try
              {
                if('author' in this_post)
                {
                  if('id' in this_post.author)
                  {
                    author_name = this.dsbClient.content.applyFilter(`formatData_lookup`, [ `authors`, this_post.author.id ] );
                    if('name' in author_name)
                    {
                      author_name = author_name.name;
                    }
                    else
                    {
                      author_name = 'missing';
                    }
                    this.page_view_settings.author = author_name;

                     // Highlite adverts
                    if('type' in this_post.author)
                    {
                      switch(this_post.author.type)
                      {
                        case "advert":
                            settings.author = 'off';
                            section_panel.classList.add('advertiser');
                            section_panel.classList.add('advertiser-category-col');
                            let advert_header = document.createElement('h3');
                            advert_header.classList.add('advert-header');
                            advert_header.innerHTML = 'Advertiser content';
                            this.classList.add('advert-background');
                            section_panel.prepend(advert_header);

                            try
                            {
                              let this_advertiser = await this.dsbClient.content.get('static','json_by_id/'+this_post.author.id,true);
                              if (this_advertiser.state=='success')
                              {
                                if(typeof this_advertiser === 'object' && this_advertiser !== null && ('data' in this_advertiser) &&  this_advertiser.data.length > 0)
                                {
                                  this_advertiser = this_advertiser.data[0];
                                  advertiser_section = document.createElement('div');
                                  advertiser_section.classList.add('advertiser-content-wrap');
                                  advertiser_section.innerHTML='<h4>Provided by '+this_advertiser.name+'</h4><span class="border-bottom"></span>';
                                  let advertiser_content = document.createElement('div');
                                  advertiser_content.classList.add('advertiser-content');
                                  /**
                                  let advertiser_logo_img = this.dsbClient.content.applyFilter(`formatData_lookup`, [ `author_advertiser_logo`, this_advertiser.id ] );
                                  if(advertiser_logo_img)
                                  {
                                    let advertiser_logo = document.createElement("div");
                                    advertiser_logo.classList.add('circle-image');
                                    advertiser_logo.setAttribute('style','background-image:url('+advertiser_logo_img+')');
                                    //advertiser_logo.classList.add('circle-image');
                                    advertiser_content.append(advertiser_logo);
                                  }
                                  */

                                  if('excerpt' in this_advertiser)
                                  {
                                    let advertiser_description = document.createElement('div');
                                    advertiser_description.innerHTML = this_advertiser.excerpt;
                                    advertiser_content.append(advertiser_description);
                                  }
                                  advertiser_section.append(advertiser_content);
                                  body_panel.append(advertiser_section);

                                }
                                else
                                {
                                  this._log('error','_render','Missing this_advertiser object',this_advertiser);
                                }
                              }
                            }
                            catch(ex)
                            {
                              this._log('error','_render','Problem with advertiser details',ex);
                            }

                            /**
                            let advertiser_logo_img = this.dsbClient.content.applyFilter(`formatData_lookup`, [ `author_advertiser_logo`, this_post.author.id ] );
                            let advertiser_logo = document.createElement("div");
                            advertiser_logo.setAttribute('style','background-image:url('+advertiser_logo_img+')');
                            advertiser_logo.classList.add('circle-image');
                            */
                            break;
                        default:
                            break;
                      }
                    }

                    if(settings.author == 'on')
                    {
                      let author_description = document.createElement('div');
                      author_description.classList='author-metadata';
                      let author_description_name = document.createElement('div');
                      author_description_name.classList='author-name';
                      author_description_name.innerHTML = 'By '+author_name;
                      author_description.append(author_description_name);
                      body_panel.append(author_description);
                    }
                  }
                }
              }
              catch(ex)
              {
                this._log('error','_render','Missing author name, may need to refresh lookup',ex);

              }



              //this.page_view_settings.contenttype=post_type;

              let body = document.createElement("div");

              let title = null;

              switch(post_type)
              {
                  case "post":
                        console.log(`Loading `+post_type+`....`);
                        if(settings.header && settings.header=='on')
                        {
                          title = document.createElement("h1");
                          title.setAttribute(`itemprop`,`headline`);
                          title.innerHTML = this_post.title;
                          body_panel.append(title);
                          body.setAttribute(`itemprop`,`articleBody`);
                        }
                        break;
                  case "fw_dsb_app_tab":
                        console.log(`Loading `+post_type+`....`);

                        if(settings.header && settings.header=='on')
                        {
                          title = document.createElement("h1");
                          title.setAttribute(`itemprop`,`headline`);
                          title.innerHTML = this_post.title;
                          body_panel.append(title);
                        }
                        break;
                  default:
                        console.log(`Loading `+post_type+`....`);
                        break;
              }
              body.innerHTML = ``;

              let has_widgets = false;
              if(`post_widgets` in this_post)
              {
                has_widgets = this._generate_post_widgets(this_post.post_widgets, body);
              }

              if(!has_widgets)
              {
                if(`content` in this_post)
                {
                    if(!has_widgets)
                    {
                        if(`rendered` in this_post.content)
                        {
                          body.innerHTML = this_post.content.rendered;
                        }
                        else
                        {
                          console.warn('Missing document.content.rendered');
                        }
                    }
                }
                else
                {
                    console.warn('Missing document.content', this_post);
                }
              }


              if(`clean_body` in settings && settings.clean_body !== 'off')
              {
                 var attr = [
                    'align',
                    'background',
                    'bgcolor',
                    'color',
                    'face',
                    'height',
                    'hspace',
                    'marginheight',
                    'marginwidth',
                    'noshade',
                    'nowrap',
                    'valign',
                    'vspace',
                    'width',
                    'vlink',
                    'alink',
                    'text',
                    'link',
                    'frame',
                    'frameborder',
                    'clear',
                    'scrolling',
                    'style/background-image'
                 ];
                if(settings.clean_body == 'full')
                {
                  attr = [
                    'align',
                    'background',
                    'bgcolor',
                    'border',
                    'cellpadding',
                    'cellspacing',
                    'color',
                    'face',
                    'height',
                    'hspace',
                    'marginheight',
                    'marginwidth',
                    'noshade',
                    'nowrap',
                    'valign',
                    'vspace',
                    'width',
                    'vlink',
                    'alink',
                    'text',
                    'link',
                    'frame',
                    'frameborder',
                    'clear',
                    'scrolling',
                    'style'
                  ];
                }
                let function__parseAtts = function(all,attr) {
                  var i = all.length;
                  var j, is_hidden;

                  // Presentational attributes.


                  var attr_len = attr.length;

                  while (i--) {
                    is_hidden = (all[i].style.display === 'none');

                    j = attr_len;

                    while (j--) {
                      if(attr[j] == 'style/background-image')
                      {
                        if(all[i].style.backgroundImage.length>0)
                        {
                          let thisbackgroundImage = all[i].style.backgroundImage.slice(5, -2).replace(/"/g, "");
                          if(thisbackgroundImage.indexOf("http") == -1)
                          {
                            all[i].style.backgroundImage = `url(`+img_path+thisbackgroundImage+`)`;
                          }
                        }
                      }
                      else
                      {
                        all[i].removeAttribute(attr[j]);
                      }
                    }

                    // Re-hide display:none elements,
                    // so they can be toggled via JS.
                    if (is_hidden) {
                      all[i].style.display = 'none';
                      is_hidden = false;
                    }
                  }
                };
                function__parseAtts(body.getElementsByTagName('*'),attr);
              }

              body_panel.append(body);

              result = true;
            }

            if(result)
            {
              // Add body
              section_panel.append(body_panel);

              this.innerHTML = ``;
              if(`background-color` in settings)
              {
                this.style.backgroundColor=settings['background-color'];
              }
              //this.append(nav_panel);
              this.append(section_panel);

              // Execute any scripts in section_panel
              Array.from(this.querySelectorAll("script")).forEach( oldScript => {
                const newScript = document.createElement("script");
                Array.from(oldScript.attributes)
                  .forEach( attr => newScript.setAttribute(attr.name, attr.value) );
                newScript.appendChild(document.createTextNode(oldScript.innerHTML));
                oldScript.parentNode.replaceChild(newScript, oldScript);
              });

              // Append body
              for(let i = 0; i < this.append_content.length; i++)
              {
                if(this.append_content[i] instanceof HTMLElement)
                {
                  this.append(this.append_content[i]);
                }
                else
                {
                  let appended_content_element = document.createElement("div");
                  appended_content_element.innerHTML = this.append_content[i];
                  this.append(appended_content_element);
                }
              }

              try
              {
                let a = this.querySelectorAll("a");
                if(a !== undefined || a.length > 0)
                {
                  switch(settings.internal_links)
                  {
                    case "modal":
                          const on_click = function() {
                            let target_id = this.getAttribute("data-target");
                            let target_type = this.getAttribute("data-target-type");
                            let query = this.getAttribute("data-query");
                            let service = this.getAttribute("data-service");

                            if(target_id)
                            {
                              let target =  document.getElementById(target_id);
                              if(target)
                              {
                                target.setAttribute('query', query);
                                target.setAttribute('service', service);
                              }
                              else
                              {
                                console.log('NO TRAGET');
                              }

                              if('dsb-modal' == target_type)
                              {
                                document.querySelector('dsb-modal').classList.toggle('show');
                              }
                            }
                            else
                            {
                              console.log('DSBSections missing ID');
                            }
                          };

                          for(let i = 0; i < a.length; i++)
                          {
                            a[i].setAttribute(`data-target`, ``+body_modal_panel_id);
                            a[i].setAttribute(`data-target-type`, `dsb-modal`);
                            a[i].setAttribute(`data-query`,`url=`+a[i].getAttribute('href'));
                            a[i].setAttribute(`data-service`,`post`);
                            a[i].setAttribute(`href`,`javascript:return;`);
                            a[i].onclick = on_click;
                          }
                          break;
                    default:
                          for(let i = 0; i < a.length; i++)
                          {

                            let href = a[i].getAttribute('href').trim();
                            a[i].setAttribute(`target`, `_blank`);

                            if(href.indexOf("#") == 0)
                            {
                              a[i].setAttribute(`data-internal_link`, href.substring(1));
                              a[i].onclick = function(){
                                var elem = document.getElementById(this.getAttribute('data-internal_link'));
                                elem.scrollIntoView();
                              };
                              a[i].setAttribute(`href`,`javascript:return;`);
                              a[i].setAttribute(`target`, `_self`);
                            }
                            else if(href.indexOf("http") == -1)
                            {
                              // check for documents
                              let extension = href.split('.');
                              if(extension.length > 1 && (extension[1] !== 'htm' && extension[1] !== 'html'))
                              {
                                a[i].setAttribute(`href`,img_path+href);
                              }
                              else
                              {
                                a[i].setAttribute(`href`,window.location.origin+href);
                              }
                            }

                          }
                          break;

                  }
                }

                let img = this.querySelectorAll("img");

                if(img !== undefined || img.length > 0)
                {
                  for(let i = 0; i < img.length; i++)
                  {
                    if(settings.lazy_images == 'on')
                    {
                      img[i].setAttribute(`loading`,'lazy');
                    }
                    else
                    {
                      //img[i].setAttribute(`loading`,'eager');
                    }
                    let src = img[i].getAttribute('src');
                    if(src.indexOf("http") == -1)
                    {
                      img[i].setAttribute(`src`,img_path+src);
                    }
                  }
                }

                // Add table-wrapper
                let tables = this.querySelectorAll("table");
                if(tables !== undefined || tables.length > 0)
                {
                  for(let i = 0; i < tables.length; i++)
                  {
                    tables[i].outerHTML = '<div class="scroll-wrapper">'+tables[i].outerHTML+'</div>';
                  }
                }



                // Set appends
                for(let i = 0; i < this.footer.length; i++)
                {
                    footer_panel.append(this.footer[i]);
                }

                if(footer_panel.childNodes.length > 0)
                {
                  this.append(footer_panel);
                }

                if(settings.page_view_onload=='on')
                {
                  this.page_view();
                }
              }
              catch(ex)
              {
                console.log(ex);
              }

              return;
            }

            this.innerHTML = `Missing post`;
        }
        else
        {
          throw {code:404,message:'No results',data:this.post_data};
        }
      }
    }
    catch(ex)
    {
      console.error('--here',ex);
      let code = 500;
      if(typeof ex === 'object' && ex !== null && ('code' in ex))
      {
        code = ex.code;
      }
      let is_offline = await this.dsbClient.user.is_offline();
      if(is_offline=='maintenance')
      {
        if(is_offline=='maintenance')
        {
          code = 'maintenance';
        }
        else
        {
          code = 503;
        }
      }

      switch(code+"")
      {
        case "404":
          this.innerHTML = `<article class="error-404" role="article">
            <p>404 :(</p>
            <p>We can't seem to find this page.</p>
          </article>`;
          break;
        case "503":
          this.innerHTML = `<article class="error-90" role="article">
            <p>Offline</p>
            <p>Sorry, offline version not available.<br/>Please try again later when you have an internet connection :)</p>
          </article>`;
          break;
        case "maintenance":
          this.innerHTML = `<article class="error-503" role="article">
            <p>Maintenance work ongoing...</p>
            <p>Sorry we are currently performing maintenance please <a href="javascript:return;" onclick="window.location.reload(false);">click here</a> to try again or check back later.</p>
          </article>`;
          break;
        default:
          this.innerHTML = `<article class="error-500" role="article">
                <p>Sorry an error has occured.</p>
                <p>
                  Please try again by <a href="javascript:return;" onclick="window.location.reload(true);">clicking here</a> or try again later.
                </p>
                <details>
                  <summary>Details</summary>
                  <div>
                    `+JSON.stringify(ex)+`
                  </div>
                </details>
              </article>`
          console.error(ex);
          break;
      }
    }

    return;
  }
}


